<app-single-detail svgIcon="feather:hash" label="ID" [value]="clientAccountDetails?.id"></app-single-detail>
<app-single-detail svgIcon="feather:clipboard" label="Name" [value]="clientAccountDetails?.name"></app-single-detail>
@if (clientAccountDetails?.corporateAccountType === null) {
  <app-single-detail
    svgIcon="feather:file-text"
    label="Account type"
    [value]="clientAccountDetails?.accountType"></app-single-detail>
}
@if (clientAccountDetails?.corporateAccountType !== null) {
  <app-single-detail
    svgIcon="feather:file-text"
    label="Account Type"
    [value]="'Corporate • ' + clientAccountDetails?.corporateAccountType"></app-single-detail>
}
